var Client = require('bitcore-wallet-client/index').default

const systemprofile = {
    verbose: false, // 能否使用未确认的积分
    // network: 'livenet',
    baseUrl: process.env.BWS_API
}

export default {
    systemprofile: systemprofile
}

export function getUtils() {
    return Client.Utils
}

export function initClient(walletData, opts) {
    opts = opts || {}
    opts.verbose = systemprofile.verbose
    var client = new Client({
        baseUrl: opts.bwsurl || systemprofile.baseUrl,
        // network: opts.network || systemprofile.network,
        verbose: opts.verbose || false
    })
    if (walletData) {
        client.import(walletData, opts)
    }
    return client
}

export function extendFromMnemonic(words) {
    return Client.Key.fromMnemonic(words)
}

export function extendFromObject(object) {
    var ireneKeys = Client.Key.fromObj(object)
    return ireneKeys
}

export function extendPrivateKey() {
    if (process.env.lang) {
        return Client.Key.create({ language: process.env.lang })
    } else {
        return Client.Key.create()
    }
}



// WEBPACK FOOTER //
// ./src/wallet/bcw.js